module.exports = __webpack_public_path__ + "media/promotional/teambuilding-e85d65bd.jpg";